export const JOURNAL_CARD_ASSET_KEYS = [
  'emotions',
  'resources',
  'thoughts',
  'body',
  'relations',
  'needs',
] as const;

export type JournalCardAssetKey = (typeof JOURNAL_CARD_ASSET_KEYS)[number];

const CATEGORY_TO_ASSET_KEY: Record<string, JournalCardAssetKey> = {
  emozioni: 'emotions',
  emotions: 'emotions',
  risorse: 'resources',
  resources: 'resources',
  pensieri: 'thoughts',
  thoughts: 'thoughts',
  corpo: 'body',
  body: 'body',
  relazioni: 'relations',
  relations: 'relations',
  bisogni: 'needs',
  needs: 'needs',
};

export const JOURNAL_CARD_BACKGROUND_URLS: Record<JournalCardAssetKey, string> = {
  emotions: 'https://cdn.emovia.com/mobile/assets/cards/emotions.webp',
  resources: 'https://cdn.emovia.com/mobile/assets/cards/resources.webp',
  thoughts: 'https://cdn.emovia.com/mobile/assets/cards/thoughts.webp',
  body: 'https://cdn.emovia.com/mobile/assets/cards/body.webp',
  relations: 'https://cdn.emovia.com/mobile/assets/cards/relations.webp',
  needs: 'https://cdn.emovia.com/mobile/assets/cards/needs.webp',
};

export const normalizeJournalCardAssetKey = (
  category?: string | null,
): JournalCardAssetKey => {
  const normalized = category?.toLowerCase().trim() ?? '';
  return CATEGORY_TO_ASSET_KEY[normalized] ?? 'emotions';
};

export const getJournalCardBackgroundUrl = (category?: string | null): string => {
  const key = normalizeJournalCardAssetKey(category);
  return JOURNAL_CARD_BACKGROUND_URLS[key];
};
